import { Permissions } from "./Permissions";

interface FunctionPermissions {
  [key: string]: string;
}

export const FunctionPermissions: FunctionPermissions = {
  getRetrieveAttachmentSignedUrl: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  approveLicenseRequest: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  setAdminNotes: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  updateContract: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  updateRates: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  createUserFromOrgAdmin: Permissions.CREATE_USER,
  createOrUpdateOrder: Permissions.MANAGE_MY_CART,
  getIncompleteOrder: Permissions.MANAGE_MY_CART,
  voidLicenseRequest: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  denyLicenseRequest: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  findOrCreateContract: Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
  getAllCustomerAccounts: Permissions.VIEW_ALL_CUSTOMER_USER,
  getAllLicenseRequests: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  getAllOrganizations: Permissions.MANAGE_ALL_ORGANIZATIONS,
  getAllProjects: Permissions.VIEW_ALL_PROJECTS,
  getAllUsersWithLicenseRequests:
    Permissions.VIEW_ALL_USERS_WITH_LICENSE_REQUESTS,
  getContractSignedUrl: Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
  getCustomerLicenseRequests: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  getCustomerProjects: Permissions.VIEW_ALL_PROJECTS,
  getLicenseRequestDetails: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  getMyCart: Permissions.MANAGE_MY_CART,
  getMyLicenseRequestDetails: Permissions.VIEW_MY_LICENSE_REQUESTS,
  getPendingAccountsSummary: Permissions.VIEW_ALL_CUSTOMER_USER,
  getProductLicenses: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  getSignedUrl: Permissions.UPLOAD_SPREADSHEET_WITH_NEW_SONGS,
  getUserFromOrgAdmin: Permissions.VIEW_MY_ORGANIZATION_USERS,
  listAllLicenseTypes: Permissions.VIEW_ALL_LICENSETYPE,
  editLicenseTypes: Permissions.EDIT_LICENSE_TYPES,
  getLicenseType: Permissions.VIEW_ALL_LICENSETYPE,
  updateMyOrganization: Permissions.UPDATE_MY_ORGANIZATION,
  updateUser: Permissions.UPDATE_MY_ORGANIZATION_USERS,
  updateWork: Permissions.UPDATE_WORK,
  getAccount: Permissions.VIEW_ALL_CUSTOMER_USER,
  approveAccount: Permissions.APPROVE_ACCOUNTS,
  denyAccount: Permissions.APPROVE_ACCOUNTS,
  deactivateUser: Permissions.APPROVE_ACCOUNTS,
  reactivateUser: Permissions.APPROVE_ACCOUNTS,
  deactivateUserFromMyOrganization:
    Permissions.DEACTIVATE_USERS_FROM_MY_ORGANIZATION,
  reactivateUserFromMyOrganization:
    Permissions.DEACTIVATE_USERS_FROM_MY_ORGANIZATION,
  deactivateOrganization: Permissions.APPROVE_ACCOUNTS,
  reactivateOrganization: Permissions.APPROVE_ACCOUNTS,
  getOrgChangeRequests: Permissions.APPROVE_ACCOUNTS,
  approveOrgChangeRequest: Permissions.APPROVE_ACCOUNTS,
  denyOrgChangeRequest: Permissions.APPROVE_ACCOUNTS,
  getDeactivationRequests: Permissions.APPROVE_ACCOUNTS,
  approveDeactivationRequest: Permissions.APPROVE_ACCOUNTS,
  denyDeactivationRequest: Permissions.APPROVE_ACCOUNTS,
  deleteOrganization: Permissions.DELETE_ORGANIZATION,
  completeOrder: Permissions.CHARGE_CREDIT_CARD,
  createStripeSetupIntent: Permissions.CREATE_CREDIT_CARD,
  createOrUpdateStripeCard: Permissions.UPDATE_MY_CREDIT_CARD,
  deleteStripePaymentMethod: Permissions.DELETE_CREDIT_CARD,
  getStripePaymentMethod: Permissions.VIEW_MY_CREDIT_CARD,
  requestDeactivation: Permissions.REQUEST_DEACTIVATION,
  requireLicenseRequestUpdates: Permissions.MANAGE_ALL_LICENSE_REQUESTS,
  changeOrganizationType: Permissions.UPDATE_ALL_ORGANIZATION,
  signContractForCustomer: Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
  signContractForIntegrity: Permissions.SIGN_LICENSE_REQUEST_CONTRACTS,
  toggleProjectActiveStatus: Permissions.UPDATE_MY_PROJECTS,
  downloadTransactionInformation: Permissions.DOWNLOAD_TRANSACTION_INFORMATION,
  downloadBatchedContracts: Permissions.DOWNLOAD_TRANSACTION_INFORMATION,
  getReportDownloadLog: Permissions.DOWNLOAD_TRANSACTION_INFORMATION,
  createAdhocAgreement: Permissions.MANAGE_ADHOC_AGREEMENTS,
  updateAdhocAgreement: Permissions.MANAGE_ADHOC_AGREEMENTS,
  getAdhocAgreements: Permissions.MANAGE_ADHOC_AGREEMENTS,
  getAdhocAgreement: Permissions.MANAGE_ADHOC_AGREEMENTS,
  createAdhocProject: Permissions.MANAGE_ADHOC_AGREEMENTS,
  updateAdhocProject: Permissions.MANAGE_ADHOC_AGREEMENTS,
  getAdhocProjects: Permissions.MANAGE_ADHOC_AGREEMENTS,
  getAdhocProject: Permissions.MANAGE_ADHOC_AGREEMENTS,
  toggleAdhocProjectStatus: Permissions.MANAGE_ADHOC_AGREEMENTS,
  uploadAdhocAgreementFile: Permissions.MANAGE_ADHOC_AGREEMENTS,
  deleteAdhocAgreementFile: Permissions.MANAGE_ADHOC_AGREEMENTS,
};
